import { parse } from 'url';
import { BaseServerConnector, ProtocolArray, ServerClientConnector } from './BaseServerConnector.js';
import { ConnectorServerConfig } from '../servers/ConnectorServer.js';
import { WebSocketServer, WebSocket, RawData } from 'ws';
import { base64ToArrayBuffer, ensureArrayBuffer, type RawBufferInput } from '@gotti/core';
export class WebSocketServerConnector extends BaseServerConnector<undefined> {
	private server : WebSocketServer;
	private sockets: Record<string, WebSocket> = {};
	constructor(c: ConnectorServerConfig) {
		super(c);
	}
	public start() {
		//console.log('websocket options was', this.config.options.websocketOptions)
		const websocketOptions = this.config.options.websocketOptions;
		this.server = new WebSocketServer({ ...websocketOptions, host: this.listenHost(websocketOptions?.host) });
		this.server.on('connection', (ws: WebSocket, req: any) => {
			try {
       // console.log('New WebSocket connection attempt');
				const { privateId, publicId } = parse(req.url, true).query;
				if(!privateId || !publicId || typeof privateId !== 'string' || typeof publicId !== 'string') {
					throw new Error(`No ids given`);
				}
				if(this._onValidateClient(privateId, publicId)) {
					//console.log('VALIDATED AND ADD CLIENT!!', { privateId, publicId });
					this.sockets[privateId] = ws;
					const connectorClient: ServerClientConnector<undefined> = {
						options: undefined,
						gotFirstAreas: false,
						reqSeq: 0,
						pendingReqs: {},
						disconnect: ws.close.bind(ws),
							send: (msg: string) => {
								ws.send(msg)
						},
						privateId,
						publicId,
							onMessage: (cb: (msg: ProtocolArray) => void) => {
								ws.on('message', (data: RawData, isBinary: boolean) => {
									if(isBinary) {
										this._onRawClientMessage(connectorClient, this.rawDataToArrayBuffer(data));
										return;
									}
									const message = this.rawDataToString(data);
									if(message) {
										cb(JSON.parse(message));
									}
								});
							},
					};
					this.addClient(connectorClient)
					ws.on('close', () => {
						if(this.clientsByPrivateId[privateId]) {
							this.removeClient(privateId);
						} else {
							delete this.sockets[privateId];
						}
					})
				} else {
					throw new Error(`Could not validate client`)
				}
			} catch (err) {
				ws.close();
			}
		});
	}

	public override removeClient(id: string) {
		delete this.sockets[id];
		super.removeClient(id);
	}

	public override sendRawToClient(clientId: string, data: RawBufferInput | string, reliable = true, ordered = true) {
		const socket = this.sockets[clientId];
		if(socket && socket.readyState === WebSocket.OPEN) {
			const payloadBuffer = typeof data === 'string' ? base64ToArrayBuffer(data) : ensureArrayBuffer(data);
			try {
				socket.send(payloadBuffer);
				return;
			} catch (err) {
				console.error(`Failed to send raw websocket frame to ${clientId}:`, err);
			}
		}
		super.sendRawToClient(clientId, data, reliable, ordered);
	}

	private rawDataToArrayBuffer(data: RawData): ArrayBuffer {
		if (Array.isArray(data)) {
			const combined = Buffer.concat(data as Buffer[]);
			return ensureArrayBuffer(combined);
		}
		return ensureArrayBuffer(data as Buffer | ArrayBuffer);
	}

	private rawDataToString(data: RawData): string {
		if(typeof data === 'string') {
			return data;
		}
		if(Array.isArray(data)) {
			return Buffer.concat(data as Buffer[]).toString();
		}
		if(Buffer.isBuffer(data)) {
			return data.toString();
		}
		if(data instanceof ArrayBuffer) {
			return Buffer.from(data).toString();
		}
		return '';
	}

	public async close() {
		if(!this.server) return;
		const clients = [...this.clients];
		clients.forEach((client) => {
			if(this.clientsByPrivateId[client.privateId]) {
				this.removeClient(client.privateId);
			} else {
				client.disconnect();
			}
		});
		this.clients.length = 0;
			return new Promise<void>((resolve, reject) => {
				this.server.close((err) => {
				if(err) {
					return reject(err);
				}
				delete this.server;
				resolve();
			});
		});
	}
}